<template>
	<div class=" flex">
		<el-main style="overflow: auto;">
			<div class="content" style="background-color: #f9f9f9;">
				<router-view />
			</div>
		</el-main>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {};
		},
		watch: {},
		methods: {},
	};
</script>

<style lang='scss' scoped>
	.content {
		margin: 12px;
	}

	.el-menu-item-group .el-menu-item-group__title {
		padding: 0 !important;
	}

	.outerMenu.el-menu-item-group .el-menu-item-group__title {
		padding: 0 !important;
	}
</style>
